import React from 'react';
import styles from './onboardingHeaderStyles';

const onboardingHeader = () => {
  return (
    <div className={styles.onboardingHeader}>
      <a href="/">
        <img src="/images/logo_darkbg_350.png" />
      </a>
    </div>
  );
};

export default onboardingHeader;
